import React from 'react';
import { useTranslation } from 'react-i18next';

import { usePartnerContext } from './index';
import Loader from '../../components/loader';

type Props = {
    children: React.ReactNode;
};

const Compass = () => (
    <svg
        viewBox="0 0 80 80"
        width="96"
        height="96"
        role="img"
        aria-hidden
        className={"mx-auto"}
    >
        <circle cx="40" cy="40" r="34" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.35" />
        <circle cx="40" cy="40" r="3" fill="currentColor" opacity="0.6" />
        <polygon points="40,12 46,40 40,44 34,40" fill="#D85A30" />
        <polygon points="40,68 34,40 40,36 46,40" fill="currentColor" opacity="0.25" />
        <text x="40" y="9" textAnchor="middle" fontSize="8" fill="currentColor" opacity="0.6">N</text>
    </svg>
);

export const PartnerGuard: React.FC<Props> = ({ children }) => {

    const { t } = useTranslation();

    const { loading, partner, error } = usePartnerContext();

    if (loading) {
        return <div id={"PartnerGuardLoader"} className={"h-[100vh] flex items-center justify-center"}>
            <Loader />
        </div>
    }

    if (!loading && !partner) return (
        <div className={"min-h-[100vh] flex items-center justify-center px-4 py-10 bg-gray-50 text-gray-800"}>
            <div className={"max-w-md w-full bg-white rounded-lg border p-8 text-center space-y-4"}>
                <Compass />
                <h1 className={"text-2xl font-bold"}>{t('partner.notFound.heading')}</h1>
                <p className={"text-gray-600"}>{t('partner.notFound.body')}</p>
                {error && (
                    <p className={"text-xs text-gray-400 font-mono"}>{error}</p>
                )}
            </div>
        </div>
    );

    // Partners without a status are treated as active (pre-existing records).
    if (partner?.status === 'INACTIVE') return (
        <div className={"min-h-[100vh] flex items-center justify-center px-4 py-10 bg-gray-50 text-gray-800"}>
            <div className={"max-w-md w-full bg-white rounded-lg border p-8 text-center space-y-4"}>
                <Compass />
                <h1 className={"text-2xl font-bold"}>{t('partner.inactive.heading')}</h1>
                <p className={"text-gray-600"}>{t('partner.inactive.body')}</p>
            </div>
        </div>
    );

    return <>{children}</>;
}
